import { createSlice } from "@reduxjs/toolkit";
import { getPrepareJobCardList } from "../../reduxApi/admin/PrepareJobCardReduxApi";

const prepareJobCardSlice = createSlice({
    name: 'prepareJobCard',
    initialState: {
        status: 'idel',
        isFiltered: false,
        prepareJobCards: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deletePrepareJobCardAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.prepareJobCards.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.prepareJobCards.splice(index, 1);
                }
            });
        },
        updatePrepareJobCardAction: (state, action) => {
            const index = state.prepareJobCards.findIndex(
                (item) => item.ROWID === action.payload.ROWID
            );

            if (index !== -1) {
                state.prepareJobCards[index] = action.payload;
            }
        },
        addPrepareJobCardAction: (state, action) => {
            state.prepareJobCards.unshift(action.payload);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getPrepareJobCardList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getPrepareJobCardList.fulfilled, (state, action) => {
                state.status = 'fulfilled';

                const rawData = action.payload?.data?.data || [];

                const jobCards = rawData.map(item => item.prepareJobCard);

                const uniqueJobCards = Object.values(
                    jobCards.reduce((acc, curr) => {
                        acc[curr.ROWID] = curr;
                        return acc;
                    }, {})
                );

                state.prepareJobCards = uniqueJobCards;
            });
    }
})
export const { deletePrepareJobCardAction, updatePrepareJobCardAction, addPrepareJobCardAction, setFilteredStatus } = prepareJobCardSlice.actions
export default prepareJobCardSlice.reducer